import React, {useCallback, useState, useEffect} from 'react'
import { PlaidLink, usePlaidLink, PlaidLinkOnSuccess, PlaidLinkOnEvent,PlaidLinkOnExit, } from 'react-plaid-link';
import { updateBankAccount, linkBankAccount } from '../../../../api/bookingAPI';
import { roles, assessment_status } from '../../../../utility/constants/constants'
import { PlaidPublicKey } from '../../../../config'
import qs from "query-string";

const Account = props => {
    const [token, setToken] = useState('');

    let bank = null
    if (props.user && props.user.account) {
        debugger
        bank = props.user.account.external_accounts.data[0]
    }
    let isDisabled = props.user.role === roles.service_provider && (props.user.assessment_status.toLowerCase() === assessment_status.SUBMITTED.toLowerCase() || props.user.assessment_status.toLowerCase() === assessment_status.FAILED.toLowerCase())

    let plaidEnv = "production";
    if (process.env.REACT_APP_ENV === 'development') {
        plaidEnv = "sandbox"
    } else if (process.env.REACT_APP_ENV === 'staging') {
        plaidEnv = "sandbox"
    } else if (process.env.REACT_APP_ENV === 'production') {
        plaidEnv = "production"
    }

    useEffect(() => {
        const createLinkToken = async () => {
            linkBankAccount().then((e) => {
            setToken(e.data.plaid_token.link_token);
            })
        };
        createLinkToken();
    }, []);

    const onSuccess = useCallback((public_token, metadata) => {
        // send public_token to your server
        console.log('Public Token: ' + public_token);
        console.log('Customer-selected account ID: ' + metadata.account_id);
        updateBankAccount({
            token: public_token,
            account_id: metadata.account_id,
        }).then((response) => {
            console.log(response);
            if (response.data.error || response.data.code) {
              //error
            } else {
              let user = props.user;
              user.account = response.data.account;
              props.editProfile(user.id, { user: { ...user } });
            }
            // let search = qs.parse(props.history.location.search);
            // if (search.tab === "account") {
            //   props.history.goBack();
            // }
          });
    }, []);

    const onExit = (exit) => {
       console.log(exit);
    }

    return (
        <div style={{ display: 'block' }} className="tab-pane active show fade" id="Account" role="tabpanel" aria-labelledby="Account-tab">
            {bank ? <h4 className="ml-4 ft_Weight_600 text-uppercase wow fadeInDown">Bank Details</h4> : null}
            <div className="row">
                {
                    bank
                        ? <div className="col-sm-12 col-md-10">
                            <div className="card bank_ac_card refer_tab_cont">
                                <div className="card-body">
                                    <h5 className="mt-0 mb-1 theme_semibold">{bank.bank_name}</h5>
                                    <div className="account_block">
                                        <span className="fellow_service_txt light_gray">Account ending in xxxx xxxx {bank.last4}</span>
                                        <span className="right_links">
                                            {
                                                // isDisabled
                                                //     ? <h3>Account Not Activated!</h3>
                                                //     :
                                                <PlaidLink
                                                    clientName="AV HERO"
                                                    env={plaidEnv}
                                                    product={["auth"]}
                                                    token={token}    
                                                    // publicKey={PlaidPublicKey()}
                                                    onExit={onExit}
                                                    onSuccess={onSuccess}
                                                    className="theme_link link_underline a_tag_to_button avoiding_element"
                                                    style={isDisabled ? { pointerEvents: 'none', padding: '0' } : null}
                                                    >
                                                    Update Bank Account
                                                    </PlaidLink>
                                            }
                                            <a href="javascript:void(0)" className="theme_link link_underline"></a>

                                        </span>
                                    </div>
                                    <span className="currency">Currency usd</span>
                                </div>
                            </div>
                        </div>
                        : <div style={{ width: '100%', textAlign: 'center' }}>
                            {
                                // isDisabled
                                //     ? <article class="art_hero_text">
                                //         <h3>Come back again to add your bank account once the account is activated.</h3>
                                //     </article>
                                //     : 
                                <PlaidLink
                                    clientName="AV HERO"
                                    env={plaidEnv}
                                    product={["auth"]}
                                    // publicKey={PlaidPublicKey()}
                                    token={token}
                                    onExit={onExit}
                                    onSuccess={onSuccess}
                                    className="theme_btn theme_primary w-420"
                                    style={null}>

                                    <span style={{color: 'black', cursor: 'pointer'}}>Connect your bank account!</span>
                                </PlaidLink>
                            }
                        </div>

                }
            </div>

        </div>
    )
}

export default Account